// src/context/ClientsProvider.js
import React, { useState, useEffect, useContext, useRef } from "react";
import api from "../../api/axios";
import { ClientContext } from "./Context";
import { Outlet } from "react-router-dom";
import Swal from "sweetalert2";
export const ClientsProvider = ({ children }) => {
  const [userData, setUserData] = useState(null);
  const [clientIsLoggedIn, setClientIsLoggedIn] = useState(false);
  const [clientIsLoading, setClientIsLoading] = useState(true);

  const isLoggedInRef = useRef(clientIsLoggedIn);

  useEffect(() => {
    isLoggedInRef.current = clientIsLoggedIn;
  }, [clientIsLoggedIn]);

  // Obtener usuario desde backend
  const fetchUserData = async () => {
    console.log("fetchUserData");
    const url = `${process.env.REACT_APP_API_URL}`;
    try {
      const response = await api.get(url + "/getclient");
      const { user, userCompany } = response.data || {};

      console.log("CLIENT:", response);

      if (user) {
        setUserData({ user, userCompany });
        setClientIsLoggedIn(true);
      } else {
        setUserData(null);
        setClientIsLoggedIn(false);
      }
    } catch (err) {
      setUserData(null);
      setClientIsLoggedIn(false);
    } finally {
      setClientIsLoading(false);
    }
  };

  // const logout = async (showConfirm = false, auto = false) => {
  //   const doLogout = async () => {
  //     try {
  //       // Solo llamar al backend si estamos realmente logueados (evita 500 si no hay cookie)
  //       if (clientIsLoggedIn.current) {
  //         await api.post("/logout");
  //       }
  //     } catch (err) {
  //       console.warn("[UserProvider] Logout backend falló", err);
  //     }

  //     // Limpiar estado React SIEMPRE
  //     setUserData({ user: null, userCompany: null });
  //     setClientIsLoggedIn(false);

  //     if (auto) {
  //       // Mostrar aviso antes de redirigir (automático)
  //       Swal.fire({
  //         title: "Sesión expirada",
  //         text: "Tu sesión ha caducado, por favor vuelve a iniciar sesión.",
  //         icon: "warning",
  //         timer: 2000,
  //         showConfirmButton: false,
  //         allowOutsideClick: false,
  //       }).then(() => {
  //         sessionStorage.clear();
  //         localStorage.clear();
  //         window.location.reload();
  //       });
  //     }
  //   };

  //   if (showConfirm) {
  //     const result = await Swal.fire({
  //       title: "Cerrar sesión",
  //       icon: "warning",
  //       html: `<p>¡Estás a punto de salir!</p><b>¿Deseas continuar?</b>`,
  //       showCancelButton: true,
  //       confirmButtonText: "Sí",
  //       confirmButtonColor: "#1ab394",
  //       cancelButtonText: "No, volver",
  //       cancelButtonColor: "#d33",
  //       reverseButtons: true,
  //     });

  //     if (result.isConfirmed) {
  //       doLogout();
  //     }
  //   } else {
  //     doLogout();
  //   }
  // };

  // Logout unificado (manual o automático). Flag 'auto' opcional.
  const logout = async (showConfirm = false, auto = false) => {
    const doLogout = async () => {
      //  Swal de carga
      await Swal.fire({
        title: "Cerrando sesión...",
        html: "Por favor espera",
        timer: 1000,
        timerProgressBar: true,
        allowOutsideClick: false,
        showCancelButton: false,
        showConfirmButton: false,
        // didOpen: () => {
        //   Swal.showLoading();
        // },
      });

      try {
        // Solo llamar al backend si estamos realmente logueados
        if (isLoggedInRef.current) {
          await api.post("/logout", {});
        }
      } catch (err) {
        console.warn("[UserProvider] Logout backend falló", err);
      }

      if (auto) {
        await Swal.fire({
          title: "Sesión expirada",
          text: "Tu sesión ha caducado, por favor vuelve a iniciar sesión.",
          icon: "warning",
          timer: 2000,
          showConfirmButton: false,
          allowOutsideClick: false,
        });
      }

      // 🧹 Limpieza total
      sessionStorage.clear();
      localStorage.clear();

      //  Limpiar estado React SIEMPRE
      setUserData({ user: null, userCompany: null });
      setClientIsLoggedIn(false);

      // window.location.replace("/");
    };

    if (showConfirm) {
      const result = await Swal.fire({
        title: "Cerrar sesión",
        icon: "warning",
        html: `<p>¡Estás a punto de salir!</p><b>¿Deseas continuar?</b>`,
        showCancelButton: true,
        confirmButtonText: "Sí",
        confirmButtonColor: "#1ab394",
        cancelButtonText: "No, volver",
        cancelButtonColor: "#d33",
        reverseButtons: true,
      });

      if (result.isConfirmed) {
        doLogout();
      }
    } else {
      doLogout();
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  return (
    <ClientContext.Provider
      value={{
        userData,
        clientIsLoggedIn,
        clientIsLoading,
        fetchUserData,
        logout,
      }}>
      {/* {children} */}
      {children ? children : <Outlet />}
    </ClientContext.Provider>
  );
};

export const useUser = () => useContext(ClientContext);
